<template>
  <div class="login-container">
    <el-card class="login-card">
      <div slot="header" class="login-header">
        <h2>后台管理系统</h2>
      </div>
      <el-form :model="loginForm" :rules="loginRules" ref="loginForm" label-width="0px">
        <el-form-item prop="username">
          <el-input 
            v-model="loginForm.username" 
            prefix-icon="el-icon-user" 
            placeholder="用户名">
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input 
            v-model="loginForm.password" 
            prefix-icon="el-icon-lock" 
            type="password" 
            placeholder="密码"
            @keyup.enter.native="handleLogin">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button 
            type="primary" 
            :loading="loading" 
            @click="handleLogin" 
            class="login-button">
            登录
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Login',
  data() {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      loginRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      },
      loading: false
    }
  },
  methods: {
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true
          
          // 创建请求配置，添加isAdmin请求头
          const config = {
            headers: {
              'manager': true
            }
          }
          
          // 发送登录请求
          axios.post('/user/login', this.loginForm, config)
            .then(response => {
              this.loading = false
              
              // 根据后端返回的状态码判断是否登录成功
              if (response.data.status === 200) {
                // 登录成功，保存token和用户名
                const token = response.data.data.token;
                debugger
                localStorage.setItem('token', token);
                localStorage.setItem('username', this.loginForm.username);
                
                this.$message({
                  message: '登录成功',
                  type: 'success'
                });
                
                // 跳转到首页
                this.$router.push('/dashboard');
              } else {
                // 登录失败，显示错误信息
                this.$message.error(response.data.message || '登录失败');
              }
            })
            .catch(error => {
              this.loading = false
              
              // 处理请求错误
              const errorMsg = error.response && error.response.data && error.response.data.message
                ? error.response.data.message
                : '网络错误，请稍后重试';
              this.$message.error(errorMsg);
              
              console.error('登录失败:', error)
            })
        }
      })
    }
  },
  created() {
    // 如果已经登录，直接跳转到首页
    if (localStorage.getItem('token')) {
      this.$router.push('/dashboard')
    }
  }
}
</script>

<style scoped>
.login-container {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f5f7fa;
}

.login-card {
  width: 400px;
}

.login-header {
  text-align: center;
}

.login-button {
  width: 100%;
}
</style> 